export default function FormRow({ children, cols = 1, className = "" }) {
  const grid = {
    1: "grid-cols-1",
    2: "grid-cols-1 sm:grid-cols-2",
    3: "grid-cols-1 sm:grid-cols-3",
    4: "grid-cols-2 sm:grid-cols-4",
  };
  return <div className={`grid gap-3 mb-3 ${grid[cols] || "grid-cols-1"} ${className}`}>{children}</div>;
}
